export const buttonGroup = {
  textAlign: 'right',
}
